module.exports = __webpack_public_path__ + "fonts/800-normal-greek.b7c4517.woff2";